import { FC, useCallback, useEffect, useRef, useState } from 'react';
import styled, { css, useTheme } from 'styled-components';
import { FInter, FlexBox } from "@brg/ui";
import { ArrowDownSVG } from "../../../../assets/16/ArrowDown";
import { createPortal } from "react-dom";
import { useRouteMatch } from "react-router-dom";
import { LinkTo } from 'shared/constants/linkTo';
import { AppTester } from 'supporting';
import {useTranslation} from "react-i18next";
import { LayoutConst } from 'core';
import { LongreadViewType } from 'shared/components/ViewTypeController/ViewTypeController';
import useAppTester from 'shared/MobileMenu/hooks/useAppTester';

const Z_INDEX_MIN_LONGREAD_SIZE = 98;

enum ScrollDirection {
  up = 'up',
  down = 'down',
}

const ButtonWrapper = styled(FlexBox)<{ isPresentation?: boolean }>`
  color: ${({ theme }) => theme.scrollUp.link};
  opacity: 0.36;
  span {
    font-weight: 600;
  }
  padding: 0 16px;
  align-items: center;
`

const ScrollUpRoot = styled.div <{ visible: boolean, direction: ScrollDirection, isPresentation?: boolean, viewType: LongreadViewType }>`
  height: 100vh;
  position: fixed;
  width: 120px;
  background: ${({ theme }) => theme.scrollUp.background};
  left: 0;
  top: 0;
  padding-top: 80px;
  opacity: ${({ visible }) => visible ? 1 : 0};
  transition: all 300ms;
  z-index: 100;
  cursor: ${({ visible }) => visible ? 'pointer' : 'auto'};

  svg {
    margin-right: 8px;
    flex-shrink: 0;
    transform: ${({ direction }) => direction === ScrollDirection.up ? 'rotate(180deg)' : 'none'};
    * {
      fill: ${({ theme }) => theme.scrollUp.link};
    }
  }
  
  :hover {
    background: ${({ theme }) => theme.scrollUp.backgroundHover};
    ${ButtonWrapper} {
      opacity: 0.47;
    }
  }

  @media (max-width: ${LayoutConst.screen.l_16}px) {
    ${({ viewType }) => viewType === LongreadViewType.fluid && css`
      z-index: ${Z_INDEX_MIN_LONGREAD_SIZE};
    `};
  }

  @media (max-width: 1439px) {
    display: none;
  }
`

const VISIBILITY_THRESHOLD = 200
const SWITCH_RESET_THRESHOLD = 500

export const ScrollUpZone: FC<{ isPresentation?: boolean, viewType?: LongreadViewType }> = ({ isPresentation, viewType }) => {
  const [visible, setVisible] = useState(false);
  const [direction, setDirection] = useState<ScrollDirection>(ScrollDirection.up);
  const prevPosition = useRef<number>(0);
  const theme = useTheme();
  const isLegals = useRouteMatch([LinkTo.legals, '/school/legals']);
  const isOnlines = AppTester.isOnlines();
  const { t } = useTranslation();

  const {
    isHseSpace
  } = useAppTester();

  const handleWindowScroll = useCallback(() => {
    if (window.scrollY > VISIBILITY_THRESHOLD) {
      if (!visible) {
        setVisible(true);
      }
      if (prevPosition.current && window.scrollY > SWITCH_RESET_THRESHOLD) {
        setPrevPosition(0)
      }
      setDirection(ScrollDirection.up);
    } else if (window.scrollY <= VISIBILITY_THRESHOLD && visible) {
      if (!prevPosition.current) {
        setVisible(false);
      } else {
        setDirection(ScrollDirection.down)
      }
    }
  }, [visible]);

  const setPrevPosition = (value: number) => {
    prevPosition.current = value;
  }

  const scrollToTop = () => {
    setPrevPosition(window.scrollY);
    window.scrollTo(0, 0)
  }

  const scrollBack = () => {
    window.scrollTo(0, prevPosition.current);
    setPrevPosition(0)
  }

  useEffect(() => {
    window.addEventListener('scroll', handleWindowScroll);
    return () => {
      window.removeEventListener("scroll", handleWindowScroll);
    }
  }, [handleWindowScroll]);

  const handleClick = useCallback(() => {
    if (direction === ScrollDirection.down) {
      scrollBack()
    } else {
      scrollToTop()
    }
  }, [direction])

  const footer = document.querySelector("#footer-portal")

  if (!footer || isLegals || isHseSpace) {
    return null;
  }

  return createPortal(
    <ScrollUpRoot viewType={viewType} visible={visible} direction={direction} onClick={handleClick} isPresentation={isPresentation}>
      {direction === ScrollDirection.up && (
        <ButtonWrapper isPresentation={isPresentation}>
          <ArrowDownSVG clr={theme.tagSearch.arrowColor} opacity={'1'}/>
          <FInter.SmallText>
            {isOnlines ? 'Top' : t('to_top')}
          </FInter.SmallText>
        </ButtonWrapper>
      )}
      {direction === ScrollDirection.down && (
        <ButtonWrapper isPresentation={isPresentation}>
          <ArrowDownSVG clr={theme.tagSearch.arrowColor} opacity={'1'}/>
        </ButtonWrapper>
      )}
    </ScrollUpRoot>,
    footer
  );
};
import { FC, useCallback, useEffect, useRef, useState } from 'react';
import styled, { css, useTheme } from 'styled-components';
import { FInter, FlexBox } from "@brg/ui";
import { ArrowDownSVG } from "../../../../assets/16/ArrowDown";
import { createPortal } from "react-dom";
import { useRouteMatch } from "react-router-dom";
import { LinkTo } from 'shared/constants/linkTo';
import { AppTester } from 'supporting';
import {useTranslation} from "react-i18next";
import { LayoutConst } from 'core';
import { LongreadViewType } from 'shared/components/ViewTypeController/ViewTypeController';
import useAppTester from 'shared/MobileMenu/hooks/useAppTester';

const Z_INDEX_MIN_LONGREAD_SIZE = 98;

enum ScrollDirection {
  up = 'up',
  down = 'down',
}

const ButtonWrapper = styled(FlexBox)<{ isPresentation?: boolean }>`
  color: ${({ theme }) => theme.scrollUp.link};
  opacity: 0.36;
  span {
    font-weight: 600;
  }
  padding: 0 16px;
  align-items: center;
`

const ScrollUpRoot = styled.div <{ visible: boolean, direction: ScrollDirection, isPresentation?: boolean, viewType: LongreadViewType }>`
  height: 100vh;
  position: fixed;
  width: 120px;
  background: ${({ theme }) => theme.scrollUp.background};
  left: 0;
  top: 0;
  padding-top: 80px;
  opacity: ${({ visible }) => visible ? 1 : 0};
  transition: all 300ms;
  z-index: 100;
  cursor: ${({ visible }) => visible ? 'pointer' : 'auto'};

  svg {
    margin-right: 8px;
    flex-shrink: 0;
    transform: ${({ direction }) => direction === ScrollDirection.up ? 'rotate(180deg)' : 'none'};
    * {
      fill: ${({ theme }) => theme.scrollUp.link};
    }
  }
  
  :hover {
    background: ${({ theme }) => theme.scrollUp.backgroundHover};
    ${ButtonWrapper} {
      opacity: 0.47;
    }
  }

  @media (max-width: ${LayoutConst.screen.l_16}px) {
    ${({ viewType }) => viewType === LongreadViewType.fluid && css`
      z-index: ${Z_INDEX_MIN_LONGREAD_SIZE};
    `};
  }

  @media (max-width: 1439px) {
    display: none;
  }
`

const VISIBILITY_THRESHOLD = 200
const SWITCH_RESET_THRESHOLD = 500

export const ScrollUpZone: FC<{ isPresentation?: boolean, viewType?: LongreadViewType }> = ({ isPresentation, viewType }) => {
  const [visible, setVisible] = useState(false);
  const [direction, setDirection] = useState<ScrollDirection>(ScrollDirection.up);
  const prevPosition = useRef<number>(0);
  const theme = useTheme();
  const isLegals = useRouteMatch([LinkTo.legals, '/school/legals']);
  const isOnlines = AppTester.isOnlines();
  const { t } = useTranslation();

  const {
    isHseSpace
  } = useAppTester();

  const handleWindowScroll = useCallback(() => {
    if (window.scrollY > VISIBILITY_THRESHOLD) {
      if (!visible) {
        setVisible(true);
      }
      if (prevPosition.current && window.scrollY > SWITCH_RESET_THRESHOLD) {
        setPrevPosition(0)
      }
      setDirection(ScrollDirection.up);
    } else if (window.scrollY <= VISIBILITY_THRESHOLD && visible) {
      if (!prevPosition.current) {
        setVisible(false);
      } else {
        setDirection(ScrollDirection.down)
      }
    }
  }, [visible]);

  const setPrevPosition = (value: number) => {
    prevPosition.current = value;
  }

  const scrollToTop = () => {
    setPrevPosition(window.scrollY);
    window.scrollTo(0, 0)
  }

  const scrollBack = () => {
    window.scrollTo(0, prevPosition.current);
    setPrevPosition(0)
  }

  useEffect(() => {
    window.addEventListener('scroll', handleWindowScroll);
    return () => {
      window.removeEventListener("scroll", handleWindowScroll);
    }
  }, [handleWindowScroll]);

  const handleClick = useCallback(() => {
    if (direction === ScrollDirection.down) {
      scrollBack()
    } else {
      scrollToTop()
    }
  }, [direction])

  const footer = document.querySelector("#footer-portal")

  if (!footer || isLegals || isHseSpace) {
    return null;
  }

  return createPortal(
    <ScrollUpRoot viewType={viewType} visible={visible} direction={direction} onClick={handleClick} isPresentation={isPresentation}>
      {direction === ScrollDirection.up && (
        <ButtonWrapper isPresentation={isPresentation}>
          <ArrowDownSVG clr={theme.tagSearch.arrowColor} opacity={'1'}/>
          <FInter.SmallText>
            {isOnlines ? 'Top' : t('to_top')}
          </FInter.SmallText>
        </ButtonWrapper>
      )}
      {direction === ScrollDirection.down && (
        <ButtonWrapper isPresentation={isPresentation}>
          <ArrowDownSVG clr={theme.tagSearch.arrowColor} opacity={'1'}/>
        </ButtonWrapper>
      )}
    </ScrollUpRoot>,
    footer
  );
};
